var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-divider',{staticClass:"mb-2 mt-0 pt-1",attrs:{"color":"","position":"center"}},[_c('div',{staticClass:"flex items-center justify-end text-xg text-dark"},[_c('p',{staticClass:"font-semibold",class:{'text-danger': _vm.title === 'overdue'}},[_vm._v("\n      "+_vm._s(_vm.title)+_vm._s(_vm.count > 0 ? ` (${_vm.count})` : '')+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }